export default "/kiban/_next/static/images/mount-52ebd0a2ee2b438266675b77ee1a71c0.png";